import type { IDCardPayload } from "@/types";
import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";

export const fetchIDCard = async (idCardPayload: IDCardPayload) => {
  const url = API_ENDPOINTS.ID_CARD;
  const { token, ...payload } = idCardPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};
